import React, { useMemo } from "react"
import ContentNormal from "components/elements/ContentNormal"
import { AppContext } from "contexts/AppContext"
import { useContext, useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import "./Shop.css"
import { callAPI } from "utils/API";
import {
    Box,
    Snackbar,
    SnackbarContent,
    Slide,
    Drawer,
    Backdrop,
    Typography,
  } from "@mui/material";
import ProductNormal from "components/elements/ProductNormal"
import { translate } from "utils/Translate";
import ButtonMedium4 from "components/elements/ButtonMedium4"
import Headline5 from "components/elements/Headline5"
import { useNavigate } from "react-router-dom";
import { createUseStyles } from "react-jss";
import CircularIndeterminate from 'components/blocks/progressBar/progressBar'
import Activity from "utils/Activity"
import _ from 'lodash'
import { setupProductImages } from "utils/productImageHelper"
import SectionWrapper from "components/layouts/SectionWrapper"
import FilterSelect from "./FilterSelect"
import { FilterChip } from "./FilterChip"
import SortSelect from "./SortSelect"
import { SearchBar } from "components/blocks/searchBar/SearchBar"
import { Tune } from "@mui/icons-material"
import ProductsScrollBlock from "components/blocks/productsScrollBlock/ProductsScrollBlock"
import { useDebounce } from "utils/useDebounce"
import { ShopFilterDrawer } from "./ShopFilterDrawer"
import { PriceFilterButton } from "./PriceFilter"
import ContentSmall from "components/elements/ContentSmall"
import ButtonMedium3 from "components/elements/ButtonMedium3"


const jss = createUseStyles({
    seeMoreButton: {
    position: "relative",
    },
    shopHeadline: {
        fontWeight: (styleGuide) => styleGuide.headline3FontWeight,
        fontSize: (styleGuide) => styleGuide.headline3FontSize,
        lineHeight: (styleGuide) => styleGuide.headline3LineHeight
    },
    shopContent: {
        fontFamily: (styleGuide) => styleGuide.secondaryFontFamily,
        fontWeight: (styleGuide) => styleGuide.contentNormalFontWeight,
        fontSize: (styleGuide) => styleGuide.contentNormalFontSize,
        lineHeight: (styleGuide) => styleGuide.contentNormalLineHeight,
    },
    "@media screen and (min-width: 1024px)": {
        seeMoreButton: {
        position: "absolute",
        marginTop: 0,
        top: '100px',
        right: '100px',
        }
    },
});

const Shop = () => {
    const { styleGuide, accessibleShops, brandData, userData, basket, defaultTheme, langCode, searchInput, setSearchInput } = useContext(AppContext);
    const isSystemAdmin = userData?.userRole?.toUpperCase() === "SYSTEM" && userData?.userPrivilege?.toUpperCase() === "MANAGE" 
    const classes = jss(styleGuide);
    const { ShopID } = useParams()
    const initialShopID = useMemo(() => ShopID, [])
    const location = useLocation()
    const navigate = useNavigate()
    const queryString = new URLSearchParams(location.search);
    
    let filterCategoryName = location.search
      ? queryString.get("category") &&
        queryString.get("category").includes("_")
        ? queryString
            .get("category")
            .split("_")
            .join(" ")
        : queryString.get("category")
      : null; 

    let filterSubCategoryName = location.search
      ? queryString.get("subCategory") &&
        queryString.get("subCategory").includes("_")
        ? queryString
            .get("subCategory")
            .split("_")
            .join(" ")
        : queryString.get("subCategory")
      : null;

    let filterBrandName = location.search
      ? queryString.get("brand") &&
        queryString.get("brand").includes("_")
        ? queryString
            .get("brand")
            .split("_")
            .join(" ")
        : queryString.get("brand")
      : null;

    let filterProductTypes = location.search
      ? queryString.get("productType") &&
        queryString.get("productType").includes("_")
        ? queryString
            .get("productType")
            .split("_")
        : queryString.get("productType") ? [queryString.get("productType")] : []
      : null;

    let shopIDs = accessibleShops.map((shop) => shop.ShopID )

    if(brandData?.features?.disableHome && !ShopID && shopIDs.length) {
        navigate(`/shop/${shopIDs[0]}`, { state: { scrollToTop: true } })
    }
    if(ShopID && accessibleShops?.length) {
        if(!shopIDs.includes(Number(ShopID))) {
            navigate('/')
        }
    }

    const deafultSortValue = 8 // Promoted first
    const defaultMaxProductPrice = 50_000
    const defaultPriceFilterValue = [0, defaultMaxProductPrice]
    const getInitialStateForUserEnteredParams = () => {
        const currentShopID = ShopID
        const userEnteredParams = JSON.parse(localStorage.getItem('userEnteredParams') || '{}')
        if(!userEnteredParams.shop) {
            return {
                searchTerm: '',
                categoryFilterValue: !!filterCategoryName ? [filterCategoryName] : [],
                subCategoryFilterValue: !!filterSubCategoryName ? [filterSubCategoryName] : [],
                sortValue: deafultSortValue,
                manufacturerFilterValue: !!filterBrandName ? [filterBrandName] : [],
                sizeFilterValue: [],
                productTypeFilterValue: !!filterProductTypes ? filterProductTypes : [],
                colorFilterValue: [],
                priceFilterValue: defaultPriceFilterValue,
                pageNumber: 1,
                offset: 0,
            }
        }
        const existingFilters = userEnteredParams.shop.find(item => Number(item.ShopID) === Number(currentShopID))
        if(!existingFilters) {
            return {
                searchTerm: '',
                categoryFilterValue: !!filterCategoryName ? [filterCategoryName] : [],
                subCategoryFilterValue: !!filterSubCategoryName ? [filterSubCategoryName] : [],
                sortValue: deafultSortValue,
                manufacturerFilterValue: !!filterBrandName ? [filterBrandName] : [],
                sizeFilterValue: [],
                productTypeFilterValue: !!filterProductTypes ? filterProductTypes : [],
                colorFilterValue: [],
                priceFilterValue: defaultPriceFilterValue,
                pageNumber: 1,
                offset: 0,
            }
        }
        const useExistingFilters = !filterCategoryName && !filterSubCategoryName && !filterBrandName && !filterProductTypes
        return {
            filtersApplied: true,
            searchTerm: existingFilters.searchString || '',
            sortValue: existingFilters.sortValue || deafultSortValue,
            categoryFilterValue: !!filterCategoryName ? [filterCategoryName] : useExistingFilters ? (existingFilters.categoryFilterValue || []) : [],
            subCategoryFilterValue: !!filterSubCategoryName ? [filterSubCategoryName] : useExistingFilters ? (existingFilters.subcategoryFilterValue || []) : [],
            manufacturerFilterValue: !!filterBrandName ? [filterBrandName] : useExistingFilters ? (existingFilters.manufacturerFilterValue || []) : [],
            sizeFilterValue: useExistingFilters ? (existingFilters.sizeFilterValue || []) : [],
            productTypeFilterValue: !!filterProductTypes ? filterProductTypes : useExistingFilters ? (existingFilters.productTypeFilterValue || []) : [],
            colorFilterValue: useExistingFilters ? (existingFilters.colorFilterValue || []) : [],
            priceFilterValue: (useExistingFilters ? (existingFilters.priceFilterValue || defaultPriceFilterValue) : defaultPriceFilterValue),
            pageNumber: existingFilters.pageNumber || '',
            offset: existingFilters.offset || 0,
        }
    }

    const initialState = useMemo(() => getInitialStateForUserEnteredParams(), [])
    const [filtersApplied, setfiltersApplied] = useState(initialState.filtersApplied)
    const [productsFiltered, setProductsFiltered] = useState([])
    const [loading, setloading] = useState(false)
    const [categoryFilterOptions, setCategoryFilterOptions] = useState([])
    const [categoryFilterValue, setCategoryFilterValue] = useState(initialState.categoryFilterValue)
    const [subcategoryFilterOptions, setSubcategoryFilterOptions] = useState([])
    const [subcategoryFilterValue, setSubcategoryFilterValue] = useState(initialState.subCategoryFilterValue)
    const [manufacturerFilterOptions, setManufacturerFilterOptions] = useState([])
    const [manufacturerFilterValue, setManufacturerFilterValue] = useState(initialState.manufacturerFilterValue)
    const [sizeFilterOptions, setSizeFilterOptions] = useState([])
    const [sizeFilterValue, setSizeFilterValue] = useState(initialState.sizeFilterValue)
    const [productTypeFilterOptions, setProductTypeFilterOptions] = useState([])
    const [productTypeFilterValue, setProductTypeFilterValue] = useState(initialState.productTypeFilterValue)
    const [colorFilterOptions, setColorFilterOptions] = useState([])
    const [colorFilterValue, setColorFilterValue] = useState(initialState.colorFilterValue)
    const [maxProductPrice, setMaxProductPrice] = useState(defaultMaxProductPrice)
    const [priceFilterValue, setPriceFilterValue] = useState(initialState.priceFilterValue)
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
    const [allItemsCount, setAllItemsCount] = useState(0)
    const [offset, setOffset] = useState(initialState.offset)
    const [shopBanner,setShopBanner] = useState({})
    const [showToast, setShowToast] = useState(false)
    const [shopBannerContent, setShopBannerContent] = useState('')
    const [pageNumber, setPageNumber] = useState(initialState.pageNumber)

    const [searchTerm, setSearchTerm] = useState(initialState.searchTerm)
    // Only updates after 700ms of no typing
    const debouncedSearch = useDebounce(searchInput, 700)

    const limit = 40;

    const [sortValue, setSortValue] = useState(initialState.sortValue)

    const fetchShopBanner = async() => {
        let shopbannerResponse = await callAPI(`/shopbanners`, 'GET')
        if (!shopbannerResponse) return
        setShopBanner(shopbannerResponse)
        const langShopBanner = shopbannerResponse.translations?.find(i => i.languageKey === langCode)
        if(langShopBanner?.content){
            setShopBannerContent(langShopBanner.content)
        }else if(shopbannerResponse.content){
            setShopBannerContent(shopbannerResponse.content)
        }
    }

    const categoryCompare = (a, b) => {
        if(a.categoryType !== b.categoryType) {
            if(a.categoryType === 'SALE') {
                return 1
            }

            if(b.categoryType === 'SALE') {
                return -1
            }
        }
        return a.categoryName.localeCompare(b.categoryName, undefined, {numeric: true})
    }

    const fetchCategories = async () => {
        let allCategories = await callAPI(`/product/${ShopID}/categories`, "GET");
        if(allCategories?.length){
            if(brandData?.features?.displaySeasonCategoriesOnly){
                allCategories = allCategories.filter(c => c.categoryType === 'SEASON')
            } else {
                allCategories = allCategories.filter(c => c.categoryType !== 'SEASON')
            }
            allCategories = allCategories.sort((a,b) => categoryCompare(a, b))
            setCategoryFilterOptions(allCategories)

            if(allCategories.length === 1 && !categoryFilterValue?.length){
                setCategoryFilterValue([allCategories[0].categoryName])
            }
        } else {
            setCategoryFilterOptions([])
        }
    }

    const fetchSubCategories = async () => {
        if(!categoryFilterValue?.length) return
        let filteredValues = categoryFilterValue
        const queryStringValue = encodeURIComponent(filteredValues.join('--'))
        let allSubCategories = await callAPI(`/product/${ShopID}/subcategories`, "GET", {query: {categories: queryStringValue}})
        if(!allSubCategories?.length) {
            setSubcategoryFilterOptions([])
            setSubcategoryFilterValue([])
            return
        }
        setSubcategoryFilterOptions(allSubCategories)
    }

    const fetchProducts = async ({ newOffset = offset, newLimit = limit, showMore = false }) => {
        setloading(true)

        if(searchInput !== searchTerm){
            return
        }

        const sizeFilter = getSizeFilterOptions().filter(option => sizeFilterValue.some(selectedSize => selectedSize === option.label)).map(s => s.value).flat().join()
        const queryParams = {
            offset: newOffset,
            limit: newLimit,
            searchTerm: searchTerm.trim() || "",
            categoryName: categoryFilterValue.join() || '',
            subCategoryName: subcategoryFilterValue.join() || '',
            sortValue: sortValue,
            manufacturerFilter: manufacturerFilterValue.join() || '',
            sizeFilter: sizeFilter || '',
            productTypeFilter: productTypeFilterValue.map(pt => pt.split(';')[0]).join() || '',
            colorFilter: colorFilterValue.map(c => c.split(';')[0]).join() || '',
            priceFilter: priceFilterValue.join() || '',
        };

        try {
            const shopProductsResult = await callAPI(`/shop/${ShopID}/productsPaged`, "GET", {
                query: queryParams,
            });
        
            const { pagedItems: shopProducts, allItemsCount, manufacturers, sizes, productTypes, colors } = shopProductsResult;

            setManufacturerFilterOptions(manufacturers.map(m => ({ label: `${m.manufacturer} (${m.productCount})`, value: m.manufacturer })))

            const displaySizes = getSizeFilterOptions()
            for(const displaySize of displaySizes){
                const amount = sizes.reduce((sum, s) => displaySize.value.some(ds => ds === s.variationSize) ? sum + s.productCount : sum, 0)
                displaySize.count = amount
            }
            setSizeFilterOptions(displaySizes.filter(s => s.count > 0).map(s => ({ label: `${s.label} (${s.count})`, value: s.label })))

            setProductTypeFilterOptions(productTypes.map(pt => ({ label: `${pt.name} (${pt.productCount})`, value: `${pt.ProductTypeID};${pt.name}` })))

            if(brandData?.features?.enableColorFilterInShop){
                setColorFilterOptions(colors.map(c => ({ label: `${c.name} (${c.productCount})`, value: `${c.ColorCategoryID};${c.name}`, hexCode: c.hexCode })))
            }

            if (shopProducts && shopProducts.length) {
                shopProducts.forEach(product => {
                    setupProductImages(product, false)
                });
        
                setProductsFiltered(prevProducts =>
                    showMore ? [...prevProducts, ...shopProducts] : shopProducts
                );

                setAllItemsCount(allItemsCount);
            } else if (!showMore) {
                setProductsFiltered([]);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setloading(false);
        }
    }

    const fetchMaxProductPrice = async () => {
        const maxPriceResult = await callAPI(`/shop/${ShopID}/maxPrice`, "GET")
        if(!maxPriceResult || isNaN(maxPriceResult)){
            return
        }

        setMaxProductPrice(maxPriceResult)
        if(priceFilterValue[1] === defaultMaxProductPrice){
            priceFilterValue[1] = maxPriceResult
        }
    }

    const productPriceFilterIsDefault = () => priceFilterValue[0] === 0 && (priceFilterValue[1] === defaultMaxProductPrice || priceFilterValue[1] === maxProductPrice)

    const getDirectLinkToShopWithFilters = (category=categoryFilterValue?.[0] || '', subcategory="") => {
        const protocol = window.location.protocol
        const basePath = window.location.host
        const contextPath = location.pathname

        if(!category) return
        let url = `${protocol}//${basePath}${contextPath}?category=${encodeURIComponent(category)}`
        if(!subcategory) return url
        url = `${url}&subCategory=${encodeURIComponent(subcategory)}`
        return url
    }

    const copyTextToClipboard = (value) => {
        if(!value) return
        if (!navigator.clipboard) {
          return console.log("Clipboard API not available")
        }
        if (window.getSelection().toString() && this.props.options.copyHightlighText) {
          return
        }
        try {
          navigator.clipboard.writeText(value).then(() => {
            setShowToast(true)
          })
          .catch((error) => {
            console.error('Error copying text to clipboard:', error);
          });
        } catch (err) {
          console.error('Failed to copy!', err)
        }
    }

    const handleAllCategoryClick = () => {
        removeSearch()
        setSubcategoryFilterValue([])
        setCategoryFilterValue([])
        Activity({activityType: 'filter',activityName: 'shop',activityArgument: 'All', activityArgumentID: ''})
    }

    const handleCategoryNameClick = (categoryName, alreadyChosen = false) => {
        if(!categoryName) return
        removeSearch();
        Activity({activityType: 'filter',activityName: 'shop',activityArgument: categoryName, activityArgumentID: ''})
        setSubcategoryFilterValue([])
        return setCategoryFilterValue(alreadyChosen ? [] : [categoryName])
    }

    const handleSubCategoryNameClick = (categoryName, alreadyChosen = false) => {
        if(!categoryName) return
        removeSearch();
        Activity({activityType: 'filter',activityName: 'shop',activityArgument: categoryName, activityArgumentID: ''})
        let chosenName = [...subcategoryFilterValue]
        if(alreadyChosen){
            chosenName = chosenName.filter(c => c !== categoryName)            
        } else {
            chosenName = [categoryName]
        }
        setSubcategoryFilterValue(chosenName)
    }

    const handleManufacturerChange = (value) => {        
        const manufacturersArray = typeof value === "string" 
            ? value.split(",").map(item => item.trim()) 
            : value.map(item => String(item)); 
    
        setManufacturerFilterValue(manufacturersArray);
    };

    const handleShowMore = () => {
        const newOffset = offset + limit
        fetchProducts({ newOffset: newOffset, showMore: true });
        setOffset(newOffset)
    };

    const handleClearAllFilters = () => {
        setManufacturerFilterValue([]);
        setPriceFilterValue(defaultPriceFilterValue);
        setSizeFilterValue([])
        setProductTypeFilterValue([])
        setColorFilterValue([])
        setPageNumber(1);
        setOffset(0);
    };

    const showMore = () => {
        if (offset + limit >= allItemsCount) return;
        setloading(true);
        setPageNumber((prev) => prev + 1);
        setloading();
        handleShowMore();

        Activity({activityType: 'filter', activityName: 'shop', activityArgument: 'Show More', activityArgumentID: ''})
    };

    const removeCategory = () => {
        setCategoryFilterValue([])
        setSubcategoryFilterValue([])
        setSortValue(deafultSortValue)
        handleClearAllFilters();
    }

    const removeSearch = () => {
        setSearchInput('')
        setSearchTerm('')
        setSortValue(deafultSortValue)
        handleClearAllFilters();
    }
    
    const removeAll = () => {
        setShopBannerContent('')
        setProductsFiltered([])
        setSearchTerm('')
        setCategoryFilterValue([])
        setSubcategoryFilterValue([])
        setSortValue(deafultSortValue)
        handleClearAllFilters();
    }

    const retainUserEnteredParams = () => {
        const userEnteredParams = JSON.parse(localStorage.getItem('userEnteredParams') || '{}')
        //debugger
        const currentShopParams = {
            ShopID,
            searchString: searchTerm,
            searchQuery: searchTerm,
            sortValue,
            manufacturerFilterValue: [...manufacturerFilterValue],
            priceFilterValue: !productPriceFilterIsDefault() ? [...priceFilterValue] : [0, defaultMaxProductPrice],
            sizeFilterValue: [...sizeFilterValue],
            productTypeFilterValue: [...productTypeFilterValue],
            colorFilterValue: [...colorFilterValue],
            categoryFilterValue: [...categoryFilterValue],
            subcategoryFilterValue: [...subcategoryFilterValue],
            pageNumber,
            offset
        }
        if(!userEnteredParams.shop || !userEnteredParams.shop.length) {
            userEnteredParams.shop = []
            userEnteredParams.shop.push(currentShopParams)
            return localStorage.setItem('userEnteredParams', JSON.stringify(userEnteredParams))
        }

        const existingFilters = userEnteredParams.shop.filter(item => Number(item.ShopID) === Number(ShopID))
        
        if(!existingFilters || !existingFilters.length) {
            userEnteredParams.shop.push(currentShopParams)
            return localStorage.setItem('userEnteredParams', JSON.stringify(userEnteredParams))
        }
        userEnteredParams.shop = userEnteredParams.shop.filter(item => Number(item.ShopID) !== Number(ShopID))
        userEnteredParams.shop.push(currentShopParams)
        return localStorage.setItem('userEnteredParams', JSON.stringify(userEnteredParams))
    }

    const htmlDecode = (input) => {
        let e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    useEffect(() => {
        if(location.state?.clearShopFilters) {
            removeCategory()
            removeSearch()
        }
    }, [location.state])

    useEffect(() => {
        if(Number(ShopID)) {
            fetchCategories();
            fetchMaxProductPrice();
        }
    }, [ShopID])

    useEffect(() => {
        if(debouncedSearch){
            removeCategory()
        }
        setSearchTerm(debouncedSearch)
    }, [debouncedSearch])

    useEffect(() => {
        if (ShopID) {
            let newLimit = 40;
            if (pageNumber) {
                newLimit = pageNumber * limit;
            }
            const params = pageNumber
                ? { newOffset: 0, newLimit: newLimit }
                : { newOffset: 0 };
            fetchProducts(params);
        }
    }, [ShopID, categoryFilterValue, subcategoryFilterValue, searchTerm, sortValue, manufacturerFilterValue, sizeFilterValue, productTypeFilterValue, colorFilterValue, priceFilterValue]);

    useEffect(() => {
        fetchShopBanner();
    }, [ShopID, accessibleShops, basket]);

    useEffect(() => {
        if(Number(ShopID)) {
            fetchCategories();
        }
    }, [ShopID, accessibleShops]);

    useEffect(() => {
        if(!categoryFilterValue?.length){
            setSubcategoryFilterOptions([])
        }
        
        if(Number(ShopID)) {
            fetchSubCategories()
        }
    },[categoryFilterValue, ShopID])

    useEffect(()=>{
        if (initialShopID === ShopID) {
            return
        }

        removeAll()
    }, [ShopID, initialShopID])

    useEffect(() => {
        if (productsFiltered && productsFiltered.length) {
            setfiltersApplied(categoryFilterValue.length > 0 ? true : false)
            const productsForGrid = productsFiltered;
            const scrollToProductIds = []
            productsForGrid.forEach((e,idx, arr) => {
                if(idx % 8) return arr[idx].htmlId = ""
                const id = `shop-product-${idx}`
                scrollToProductIds.push(id)
                return arr[idx].htmlId = id
            });
            retainUserEnteredParams()
            const scrollTo = Number(sessionStorage.getItem('scrollPosition')) || 0
            if(scrollTo && scrollTo <= document.body.clientHeight){
                window.scrollTo( 0, scrollTo);
                sessionStorage.removeItem('scrollPosition')
            }
        }
    }, [productsFiltered, document.body.clientHeight, loading]);

    useEffect(() => {
        if(brandData?.features?.enableCopyingShopFilterDirectLink){
            if(isSystemAdmin){
                const urlToBeCopied = getDirectLinkToShopWithFilters(categoryFilterValue?.[0] || "", subcategoryFilterValue?.[0] || manufacturerFilterValue?.[0] || "")
                copyTextToClipboard(urlToBeCopied)
            }
        }
    },[categoryFilterValue, subcategoryFilterValue, manufacturerFilterValue])

    const noCategoryChosen = categoryFilterValue?.length <= 0

    const bannerStyle1 = { display: 'flex', width: '100%', flexDirection: 'column'}
    const bannerStyle = defaultTheme === 'ThemeONE' ? { ...bannerStyle1 } : defaultTheme === 'ThemeTWO' ? { ...bannerStyle1, marginTop: '-180px' } : { ...bannerStyle1,marginTop: 'unset' };
    let {shopPageBannerColor}= brandData && brandData.features

    const someFilterSelected = manufacturerFilterValue.length > 0
        || sizeFilterValue.length > 0
        || productTypeFilterValue.length > 0
        || colorFilterValue.length > 0
        || !productPriceFilterIsDefault()

    return (
        <>
            <Backdrop
                sx={{ zIndex: 5, backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                open={(loading)}
            >
                <CircularIndeterminate size={50} />
            </Backdrop>
            {brandData?.features?.hideShopSearch
                ? 
                <SectionWrapper backgroundColor={shopPageBannerColor|| styleGuide.color14}>
                    <div id="shop-banner" style={{...bannerStyle, 
                        backgroundColor: shopPageBannerColor|| styleGuide.color14,
                        minHeight: '250px',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <div id={`${defaultTheme}shop_banner_text`} style={{paddingTop: 100, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <span
                                    style={{
                                        fontFamily: styleGuide.fontFamily,
                                        fontStyle: 'normal',
                                        color: shopBanner.textColor || 'black',
                                        textAlign: 'center',

                                    }}
                                    className={classes.shopHeadline}
                                    dangerouslySetInnerHTML={{
                                        __html: htmlDecode(!ShopID ? translate('_SHOP_BANNER_HEADLINE_', ' ') : translate('_SHOP_BANNER_HEADLINE_',
                                            shopBanner.translations?.length
                                                ? shopBanner.translations.find(l => l.languageKey === langCode)?.title
                                                : shopBanner.title || ' '
                                        ))
                                    }}
                                >
                                </span>
                                {!isNaN(ShopID) && !!shopBannerContent && <div style={{marginTop: 14}}>
                                    <span
                                        style={{
                                            fontStyle: 'normal',
                                            color: shopBanner.textColor || 'black',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                        }}
                                        className={classes.shopContent}
                                        dangerouslySetInnerHTML={{
                                            __html: htmlDecode(translate('_SHOP_BANNER_CONTENT_', shopBannerContent))
                                        }}
                                    >
                                    </span>
                                </div>}
                            </div>
                        </div>
                    </div> 
                </SectionWrapper>
                :
                <SectionWrapper>
                    <Box
                        paddingTop={2}
                        display={{
                            xs: 'block',
                            md: 'none'
                        }}
                    >
                        <SearchBar />
                    </Box>
                </SectionWrapper>
            }

            {/* Categories */}
            { !!brandData?.features?.hideShopFilters
                ? <div style={{marginTop: 50}}></div>
                : <SectionWrapper>
                    <Box display={'flex'} flexDirection={'column'} paddingTop={2}>
                        <Box display={'flex'} flexWrap={'wrap'} gap={2} justifyContent={"center"} paddingY={2} borderBottom={`1px solid ${styleGuide.color3}`}>
                            {
                                !!brandData.features.showAllCategoryInShop && !!categoryFilterOptions?.length > 1 &&
                                    <ContentNormal
                                        key={`all-category`}
                                        className="category-label"
                                        style={{
                                            cursor: "pointer",
                                            color: noCategoryChosen ? styleGuide.color16 : styleGuide.color7,
                                            fontWeight: noCategoryChosen ? "500" : "400"
                                        }}
                                        onClick={handleAllCategoryClick}
                                        fallbackText={'Alle'}
                                        translationKey={'_ALL_'}
                                    />
                            }
                            {
                                categoryFilterOptions?.length > 1 && categoryFilterOptions?.map(c => {
                                    const isCategoryChosen = categoryFilterValue.includes(c.categoryName) 
                                    return (
                                        <ContentNormal
                                            key={`${c?.CategoryID || 0}-${c.categoryName}`}
                                            className="category-label"
                                            style={{
                                                cursor: "pointer",
                                                color: isCategoryChosen ? styleGuide.color16 : styleGuide.color7,
                                                fontWeight: isCategoryChosen ? "500" : "400"
                                            }}
                                            onClick={() => handleCategoryNameClick(c.categoryName, isCategoryChosen)}
                                        >
                                            {
                                                !!c && !!c.translations && !!c.translations.length > 0
                                                    ? c.translations.find(
                                                        (translation) => translation.languageKey === langCode
                                                    )
                                                        ? c.translations.find(
                                                            (translation) => translation.languageKey === langCode
                                                        ).categoryName
                                                        : c.categoryName
                                                    :
                                                    c.categoryName
                                            }
                                        </ContentNormal>
                                    )
                                })
                                
                            }
                        </Box>
                    </Box>
                </SectionWrapper>
            }
            {/* Sub categories */}
            <SectionWrapper backgroundColor={styleGuide.color3}>
                { !!categoryFilterValue && !!subcategoryFilterOptions?.length &&                   
                    <Box width={'100%'} overflow={'auto'} paddingY={{xs: 4, sm: 6}}>
                        <Box display={'flex'} width={'max-content'} minWidth={'100%'} justifyContent={'center'} gap={3}>
                            { subcategoryFilterOptions?.sort((a, b) => a.subCategoryName.localeCompare(b.subCategoryName)).map((sc,scidx) => {
                                const isSubCategoryChosen = subcategoryFilterValue.includes(sc.subCategoryName)
                                return (
                                    <Box
                                        key={sc.subCategoryName}
                                        sx={{cursor: 'pointer'}}
                                        width={{
                                            xs: 100,
                                            md: 140,
                                            lg: 180,
                                        }}
                                        minWidth={{
                                            xs: 100,
                                            md: 140,
                                            lg: 180,
                                        }}
                                        onClick={() => handleSubCategoryNameClick(sc.subCategoryName, isSubCategoryChosen)}
                                        display={'flex'}
                                        flexDirection={'column'}
                                        gap={1}
                                    >
                                        <img src={sc.imageURL} style={{ objectFit: 'cover', aspectRatio: 0.72, overflow: 'hidden', backgroundColor: '#e5e5e5' }} />
                                        <Typography
                                            key={`${scidx}_${sc}`}
                                            className="category-label"
                                            sx={{
                                                cursor: "pointer",
                                                color: isSubCategoryChosen ? styleGuide.color16 : styleGuide.color7,
                                                fontWeight: isSubCategoryChosen ? "500" : "400",
                                                fontSize: { xs: 12, md: 13, lg: 14 },
                                                textAlign: 'center',
                                                overflow: 'hidden',
                                            }}
                                            
                                        >
                                            { !!sc && !!sc.translations && !!sc.translations.length > 0
                                                ? sc.translations.find(
                                                    (translation) => translation.languageKey === langCode
                                                )
                                                    ? sc.translations.find(
                                                        (translation) => translation.languageKey === langCode
                                                    ).subCategoryName
                                                    : sc.subCategoryName
                                                :
                                                sc.subCategoryName
                                            }
                                        </Typography>
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>
                }
            </SectionWrapper>
            <SectionWrapper>
                {
                    <Box display="flex" flexDirection="column" width="100%" paddingTop={3}>
                        {!brandData?.features?.hideShopFilters &&
                            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" gap={2} flexWrap={'wrap'} sx={{paddingX: {xs: 2, md: 0}}}>
                                <Box
                                    sx={{
                                        display: {
                                            xs: "flex",
                                            sm: "none",
                                        },
                                        gap: 2,
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setIsFilterDrawerOpen(true)}
                                        style={{
                                            padding: "9px 0px",
                                            border: 'none',
                                            borderRadius: 20,
                                            background: "white",
                                            textAlign: "left",
                                            cursor: "pointer",
                                            display: 'flex',
                                            gap: 10,
                                        }}
                                    >
                                        <Tune sx={{color: styleGuide.color7}} />
                                        <ContentSmall>{translate('_SHOP_FILTERS_LABEL_', 'Filtre')}</ContentSmall>
                                    </button>
                                </Box>
                                <Box
                                    sx={{
                                        display: {
                                            xs: "none",
                                            sm: "flex",
                                        },
                                        gap: 2,
                                    }}
                                >
                                    <Box display={'flex'} flexWrap={'wrap'} gap={2}>
                                        {!brandData?.features?.hideBrandsInShopFilter &&
                                            <FilterSelect
                                                label={translate('_MANUFACTURER_FILTER_LABEL_', 'Brands')}
                                                enableSearch={true}
                                                onApply={handleManufacturerChange}
                                                value={manufacturerFilterValue}
                                                options={manufacturerFilterOptions}
                                            />
                                        }
                                        <FilterSelect
                                            label={translate('_SIZE_FILTER_LABEL_', 'Størrelse')}
                                            onApply={setSizeFilterValue}
                                            value={sizeFilterValue}
                                            options={sizeFilterOptions}
                                        />
                                        <FilterSelect
                                            label={translate('_PRODUCT_TYPE_FILTER_LABEL_', 'Produkttyper')}
                                            onApply={setProductTypeFilterValue}
                                            value={productTypeFilterValue}
                                            options={productTypeFilterOptions}
                                            enableSearch={true}
                                        />
                                        <FilterSelect
                                            label={translate('_COLOR_FILTER_LABEL_', 'Farver')}
                                            onApply={setColorFilterValue}
                                            value={colorFilterValue}
                                            options={colorFilterOptions}
                                            enableColor={true}
                                        />
                                        {!brandData?.features?.disablePriceFilterInShop &&
                                            <PriceFilterButton
                                                label={translate('_PRICE_FILTER_LABEL_', 'Pris')}
                                                onApply={setPriceFilterValue}
                                                value={priceFilterValue}
                                                maxValue={maxProductPrice}
                                            />
                                        }
                                    </Box>
                                </Box>
                                <SortSelect value={sortValue} onApply={setSortValue}/>
                            </Box>
                        }

                        <Box
                            sx={{
                                display: {
                                    xs: "none",
                                    sm: "flex",
                                },
                            }}
                        >
                            {someFilterSelected &&
                                <Box paddingTop={2} display="flex" gap={1} flexWrap="wrap" alignItems="center">
                                    {manufacturerFilterValue.map((manufacturer) => (
                                        <FilterChip
                                            key={manufacturer}
                                            label={manufacturer}
                                            onClear={() => setManufacturerFilterValue((prev) => prev.filter((item) => item !== manufacturer))}
                                        />
                                    ))}

                                    {sizeFilterValue.map((size) => (
                                        <FilterChip
                                            key={size}
                                            label={size}
                                            onClear={() => setSizeFilterValue((prev) => prev.filter((item) => item !== size))}
                                        />
                                    ))}

                                    {productTypeFilterValue.map((productType) => (
                                        <FilterChip
                                            key={productType}
                                            label={productType.split(';')[1]}
                                            onClear={() => setProductTypeFilterValue((prev) => prev.filter((item) => item !== productType))}
                                        />
                                    ))}

                                    {colorFilterValue.map((color) => (
                                        <FilterChip
                                            key={color}
                                            label={color.split(';')[1]}
                                            onClear={() => setColorFilterValue((prev) => prev.filter((item) => item !== color))}
                                        />
                                    ))}

                                    {!productPriceFilterIsDefault() &&
                                        <FilterChip
                                            label={`${priceFilterValue[0].toLocaleString('da-DK')} - ${priceFilterValue[1].toLocaleString('da-DK')} ${translate("_POINTS_", "point")}`}
                                            onClear={() => setPriceFilterValue(() => defaultPriceFilterValue)}
                                        />
                                    }
                                    <ButtonMedium3
                                        showIcon={false}
                                        onClick={handleClearAllFilters}
                                        translationKey="_SHOP_FILTER_CLEAR_"
                                        fallbackText="Nulstil"
                                    />
                                </Box>
                            }
                        </Box>
                    </Box>
                }
                <div>
                    <div style={{display: 'flex', flexDirection: 'row' }} >
                    {(productsFiltered.length === 0 && !loading)
                    ?   <div className="shop-content" style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem'}}>
                                <Headline5 translationKey="_SHOP_FILTER_NO_RESULTS_CAPTION_" fallbackText="Ingen resultater" />
                                <ContentNormal translationKey="_SHOP_FILTER_NO_RESULTS_TEXT_" fallbackText="Vi fandt ingen resultater" />
                            </div>
                        </div>
                    :
                        <div className="shop-content" style={{ display: 'flex', flexDirection: 'column' }}>
                                {
                                    !loading && !productsFiltered?.length && !!filtersApplied && !searchTerm.trim() && 
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem'}}>
                                        <Headline5 translationKey="_SHOP_FILTER_NO_RESULTS_CAPTION_" fallbackText="Ingen resultater" />
                                        <ContentNormal translationKey="_SHOP_FILTER_NO_RESULTS_TEXT_" fallbackText="Vi fandt ingen resultater" />
                                    </div>
                                }
                                {
                                    (!productsFiltered || !productsFiltered.length) && (!!searchTerm?.trim() && !!filtersApplied) && 
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem'}}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <Headline5 translationKey="_SHOP_SEARCH_NO_RESULTS_CAPTION_" fallbackText="Ingen resultater for" />
                                            <span>&nbsp;</span>
                                            <Headline5 fallbackText={` “${searchTerm}”`} />
                                        </div>
                                        <ContentNormal translationKey="_SHOP_SEARCH_NO_RESULTS_TEXT_" fallbackText="Vi fandt ingen resultater, der matcher din søgning. Søg igen eller brug filteringsmulighederne." />
                                    </div>
                                }
                                {
                                    (!!productsFiltered && !!productsFiltered.length) && !!filtersApplied && !!searchTerm?.trim() && 
                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '3rem'}}>
                                        <Headline5 fallbackText={`${productsFiltered.length} `} />
                                        <span>&nbsp;</span>
                                        <Headline5 translationKey="_SHOP_SEARCH_RESULTS_CAPTION_" fallbackText="resultat for" />
                                        <span>&nbsp;</span>
                                        <Headline5 fallbackText={` “${searchTerm}”`} />
                                    </div>
                                }
                                {
                                    (!!productsFiltered && !!productsFiltered.length) && 

                                    <Box
                                        display={'grid'}
                                        gridTemplateColumns={{
                                            xs: `repeat(auto-fill, ${styleGuide.productNormalWidthMobile}px)`,
                                            sm: `repeat(auto-fill, ${styleGuide.productNormalWidth}px)`,
                                        }}
                                        columnGap={{
                                            xs: 1,
                                            sm: 2,
                                            md: 4,
                                        }}
                                        rowGap={{
                                            xs: 6,
                                            md: 8,
                                        }}
                                        justifyContent={{
                                            xs: 'space-around',
                                            md: 'space-between'
                                        }}
                                        paddingTop={{xs: 4, md: 8}}
                                    >
                                        { productsFiltered.map(item => {
                                            const firstVariationUID = brandData?.features?.displayVariationUidOnShopPage && item.variationsStockCount?.length ? item.variationsStockCount[0].variationUID : ''
                                            return (
                                                    <ProductNormal
                                                        key={item.ProductID || item.ProductPackageID}
                                                        storeScrollPosition={true}
                                                        ProductID={item.ProductID}
                                                        ProductPackageID={item.ProductPackageID}
                                                        ShopID={item.ShopID}
                                                        showDiscountTag={item.enableDiscount ? true : false}
                                                        tagOptions={{
                                                            fallbackText: `${translate('_PRODUCT_DISCOUNT_TAG_TEXT_', 'Spar')} ${Math.round((item.sellingPrice.nonDiscountAmount - item.sellingPrice.amount) / item.sellingPrice.nonDiscountAmount * 100)}%`,
                                                            showClose: false,
                                                        }}
                                                        tagStyles={{borderRadius: 8}}
                                                        sticker={!!brandData && !!brandData.features && !!brandData.features.shopProductPriceButton && !!brandData.features.priceTag ? "PRICETAG" : item.flag && item.flag !== 'STICKY' ? item.flag : null}
                                                        price={item.sellingPrice}
                                                        productReaction={item.reaction}
                                                        className="productlarge"
                                                        style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"}}
                                                        text2={item.translations?.find((translation) => translation.languageKey === langCode)?.elementTitle ?? item.elementTitle}
                                                        text1={item.manufacturer}
                                                        imageSrc={`url(${item.image?.src})`}
                                                        hoverImageSrc={item.hoverImage ? `url(${item.hoverImage.src})` : ''}
                                                        imageBackgroundColor={item.image?.backgroundColor}
                                                        hoverImageBackgroundColor={item.hoverImage?.backgroundColor}
                                                        activityName='shop'
                                                        totalVariationStock={item.totalVariationStock}
                                                        variationUID={firstVariationUID}
                                                    />
                                            )
                                        })}
                                    </Box>
                                }
                                
                        </div>
                    }
                    </div>
                    {!!productsFiltered && !!productsFiltered.length && 
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "50px"}}>
                            {!loading && 
                                <div>
                                    <div style={{ marginBottom: 10 }}> 
                                        <span>Viser <span style={{fontWeight: 600}}>{productsFiltered.length}</span> ud af <span style={{fontWeight: 600}}>{allItemsCount}</span></span>
                                    </div>
                                    
                                    <div style={{ width: "100%", height: "1px", backgroundColor: "#BFBFBF", margin: "10px 0" }}></div>
                                    {productsFiltered.length !== allItemsCount &&
                                        <div style={{ display: "flex", justifyContent: "center"}}>
                                            <ButtonMedium4
                                                onClick={() => showMore()}
                                                style={{ marginTop: 10 }}
                                                showIcon={false}
                                                fallbackText="Vis flere"
                                            />
                                        </div>
                                    }
                                </div>
                            }
                            
                            
                        </div>
                    }
                </div>
            </SectionWrapper>

            <SectionWrapper sx={{paddingTop: 6}}>
                <ProductsScrollBlock
                    category={translate("_OTHERS_BOUGHT_BLOCK_CATEGORY_", "ANDRE KØBTE")}
                    caption={translate("_OTHERS_BOUGHT_BLOCK_CAPTION_", "Mest populære produkter")}
                    fetchProducts={async () => await callAPI("/product/popularProducts", "GET")}
                />
            </SectionWrapper>

            <Snackbar
                open={showToast}
                onClose={() => setShowToast(false)}
                TransitionComponent={Slide}
                TransitionProps={{direction:"up"}}
                message="URL copied"
                autoHideDuration={1200}
            >
                <SnackbarContent 
                    style={{ backgroundColor: styleGuide.color16 ,}}
                    message="URL copied"
                />
            </Snackbar>

            <ShopFilterDrawer
                isOpen={isFilterDrawerOpen}
                onClose={() => setIsFilterDrawerOpen(false)}
                brandOptions={manufacturerFilterOptions}
                sizeOptions={sizeFilterOptions}
                productTypeOptions={productTypeFilterOptions}
                colorOptions={colorFilterOptions}
                maxPriceValue={maxProductPrice}
                manufacturerFilterValue={manufacturerFilterValue}
                sizeFilterValue={sizeFilterValue}
                productTypeFilterValue={productTypeFilterValue}
                colorFilterValue={colorFilterValue}
                priceFilterValue={priceFilterValue}
                onApply={(v) => {
                    handleManufacturerChange(v.selectedManufacturers)
                    setSizeFilterValue(v.selectedSizes)
                    setPriceFilterValue(v.selectedPriceRange)
                    setProductTypeFilterValue(v.selectedProductTypes)
                    setColorFilterValue(v.selectedColors)
                    setIsFilterDrawerOpen(false)
                }}
            />
        </>
    );
}

function getSizeFilterOptions(){
    return [
        {label: 'XS', value: ['XS', 'XS/S', 'XS-S', 'XS/herre', 'XS/dame']},
        {label: 'S', value: ['S', 'XS/S', 'XS-S', 'S/M', 'S-M', 'S/herre', 'S/dame']},
        {label: 'M', value: ['M', 'S/M', 'S-M', 'M/L', 'M-L', 'M/herre', 'M/dame']},
        {label: 'L', value: ['L', 'M/L', 'M-L', 'L/XL', 'L-XL', 'L/herre', 'L/dame']},
        {label: 'XL', value: ['XL', 'L/XL', 'L-XL', 'XL/XXL', 'XL-XXL', 'XL/herre', 'XL/dame']},
        {label: 'XXL', value: ['XXL', 'XL/XXL', 'XL-XXL', 'XXL/XXXL', 'XXL-XXXL', 'XXL/herre', 'XXL/dame']},
        {label: '3XL', value: ['XXXL', '3XL', 'XXL/XXXL', 'XXL-XXXL', '3XL/4XL', '3XL-4XL']},
        {label: '4XL', value: ['XXXXL', '4XL', '3XL/4XL', '3XL-4XL']},

        {label: '36', value: ['36', '36 1/3', '36,5', '36 2/3', '36-37', '36/3,5 UK']},
        {label: '37', value: ['37', '37 1/3', '37,5', '37 2/3', '36-37', '37-38', '37/4 UK']},
        {label: '38', value: ['38', '38 1/3', '38,5', '38 2/3', '37-38', '38-39', '38/5 UK']},
        {label: '39', value: ['39', '39 1/3', '39,5', '39 2/3', '38-39', '39-40', '39/5,5 UK']},
        {label: '40', value: ['40', '40 1/3', '40,5', '40 2/3', '39-40', '40-41', '40/6,5 UK']},
        {label: '41', value: ['41', '41 1/3', '41,5', '41 2/3', '40-41', '41-42', '41/7 UK']},
        {label: '42', value: ['42', '42 1/3', '42,5', '42 2/3', '41-42', '42-43', '42/8 UK']},
        {label: '43', value: ['43', '43 1/3', '43,5', '43 2/3', '42-43', '43-44', '43/8,5 UK']},
        {label: '44', value: ['44', '44 1/3', '44,5', '44 2/3', '43-44', '44-45', '44/9,5 UK']},
        {label: '45', value: ['45', '45 1/3', '45,5', '45 2/3', '44-45', '45-46', '45/10,5 UK']},
        {label: '46', value: ['46', '46 1/3', '46,5', '46 2/3', '45-46', '46-47', '46/11 UK']},
        {label: '47', value: ['47', '47 1/3', '47,5', '47 2/3', '46-47', '47-48', '47/12 UK']},
        {label: '48', value: ['48', '48 1/3', '48,5', '48 2/3', '47-48', '48-49', '48/12,5 UK']},
        {label: '49', value: ['49', '49 1/3', '49,5', '49 2/3', '48-49', '49-50', '49/13,5 UK']},

        {label: '6', value: ['6', '6,5', '6.5']},
        {label: '7', value: ['7', '7,5', '7.5']},
        {label: '8', value: ['8', '8,5', '8.5']},
        {label: '9', value: ['9', '9,5', '9.5']},
        {label: '10', value: ['10', '10,5', '10.5']},
        {label: '11', value: ['11', '11,5', '11.5']},
        {label: '12', value: ['12', '12,5', '12.5']},
        {label: '13', value: ['13', '13,5', '13.5']},
        {label: '14', value: ['14', '14,5', '14.5']},
        {label: '15', value: ['15', '15,5', '15.5']},
    ]
}

export default Shop
